import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InputTextModule} from "primeng/inputtext";
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {ButtonModule} from "primeng/button";
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {FieldErrorComponent} from "../field-error/field-error.component";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'input-send',
    imports: [
        InputTextModule,
        FormsModule,
        ButtonModule,
        FaIconComponent,
        FieldErrorComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    templateUrl: './input-send.component.html',
    styleUrl: './input-send.component.css'
})
export class InputSendComponent implements OnInit {
  @Input() pattern = ""
  @Output() onValidate = new EventEmitter<string>()

  faArrowRight = faArrowRight

  sendForm: UntypedFormGroup

  constructor(private builder: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.sendForm = this.builder.group(
      {
        field: new UntypedFormControl('', [
          Validators.pattern(this.pattern),
          Validators.required
        ])
      }
    );
  }

  submit() {
    if(this.sendForm.valid) {
      this.onValidate.emit(this.sendForm.controls.field.value)
    }
  }
}
